export default __webpack_public_path__ + "static/media/512x512simba.0cdf440f.png";